import { gql } from '@apollo/client';

/**
 * 根据途径点ID分页查询卸车包裹明细（直接查询tms_unloading_order_detail表）
 * 不包含overallStatus筛选时使用此接口，性能更好
 */
export const GET_UNLOADING_ORDER_DETAILS_BY_WAYPOINT_ID = gql`
    query GetUnloadingOrderDetailsByWaypointId(
        $waypointId: Long!
        $pageRequest: PageRequestTypeInput
        $trackingNumber: String
        $sortingCode: String
        $loadingWaypointId: Long
        $overallStatus: String
    ) {
        getUnloadingOrderDetailsByWaypointId(
            waypointId: $waypointId
            pageRequest: $pageRequest
            trackingNumber: $trackingNumber
            sortingCode: $sortingCode
            loadingWaypointId: $loadingWaypointId
            overallStatus: $overallStatus
        ) {
            content {
                id
                trackingNumber
                overallStatus
                sortingCode
                bagNumber
                bagTaskNumber
                loadingWaypointSortingCode
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface UnloadingOrderDetailInfoType {
    id: string;
    trackingNumber: string;
    overallStatus: string;
    sortingCode: string | null;
    bagNumber: string;
    bagTaskNumber: string | null;
    loadingWaypointSortingCode: string | null;
}

export interface GetUnloadingOrderDetailsByWaypointIdResponse {
    getUnloadingOrderDetailsByWaypointId: {
        content: UnloadingOrderDetailInfoType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface GetUnloadingOrderDetailsByWaypointIdVariables {
    waypointId: number;
    pageRequest?: {
        page: number;
        size: number;
    };
    trackingNumber?: string;
    sortingCode?: string;
    loadingWaypointId?: number;
    overallStatus?: string;
}

